import { Injectable } from '@angular/core';
import type { ReportDescriptorInterface } from '@zaoblako/shared/common/dtos/report/report-descriptor.dto';
import type { HelpdeskTaskFindInterface } from '@zaoblako/shared/modules/helpdesk/dto/helpdesk-task-find.dto';
import { HelpdeskTaskTemplateAllQueryInterface } from '@zaoblako/shared/modules/helpdesk/dto/template/helpdesk.task.template.all.query.dto';
import type { HelpdeskTaskTemplateFindInterface } from '@zaoblako/shared/modules/helpdesk/dto/template/helpdesk-task-template-find.dto';
import type { HelpdeskTaskTemplatePageInterface } from '@zaoblako/shared/modules/helpdesk/dto/template/helpdesk-task-template-page.dto';
import type { HelpdeskTaskTemplateRegistryQueryInterface } from '@zaoblako/shared/modules/helpdesk/dto/template/helpdesk-task-template-registry-query.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HelpDeskTaskTemplateService extends BaseService {
  protected baseUrl = '/helpdesk/task-template';

  public getRegistryDescriptor(): Observable<ReportDescriptorInterface> {
    return this.http.get<ReportDescriptorInterface>(`${this.baseUrl}/registry-descriptor`);
  }

  public findPage(queryParams?: HelpdeskTaskTemplateRegistryQueryInterface): Observable<HelpdeskTaskTemplatePageInterface> {
    return this.http.get<HelpdeskTaskTemplatePageInterface>(`${this.baseUrl}/items`, {
      params: queryParams ? this.objectToHttpParams(queryParams as Record<string, unknown>) : {}
    });
  }

  public findAll(queryParams?: HelpdeskTaskTemplateAllQueryInterface): Observable<HelpdeskTaskTemplateFindInterface[]> {
    return this.http.get<HelpdeskTaskTemplateFindInterface[]>(`${this.baseUrl}/all`, {
      params: this.objectToHttpParams(queryParams)
    });
  }

  public clone(templateId: number): Observable<HelpdeskTaskTemplateFindInterface> {
    return this.http.get<HelpdeskTaskTemplateFindInterface>(`${this.baseUrl}/${templateId}/clone`);
  }

  public getCreatedTasksWidget(templateId: number): Observable<HelpdeskTaskFindInterface[]> {
    return this.http.get<HelpdeskTaskFindInterface[]>(`${this.baseUrl}/${templateId}/created-tasks`);
  }
}
